import {
    ANNOTATION_VIDEO_DISPLAY,
    // ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    // ANNOTATION_LOCATION,
    // VIDEO_SRC_TYPE
} from './GlobalConstants';
import * as THREE from "three";
// import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/silk-road%2Fvenice-2023%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";

const INFO_TAG = '/assets/sprites/project_sprites/Info.svg';


const AnnotationsDB = [

    /* Audio */
    {
        paintingId: 'VENGLA_A052_I',
        videoId: 'VENGLA_A052_I',
        standaloneVideoElementId: 'VENGLA_A052_I',
        videoURL: 'VENGLA_A052_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A002_E',
        videoId: 'VENREL_A002_E',
        standaloneVideoElementId: 'VENREL_A002_E',
        videoURL: 'VENREL_A002_E.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A002_I',
        videoId: 'VENREL_A002_I',
        standaloneVideoElementId: 'VENREL_A002_I',
        videoURL: 'VENREL_A002_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A006_E',
        videoId: 'VENREL_A006_E',
        standaloneVideoElementId: 'VENREL_A006_E',
        videoURL: 'VENREL_A006_E.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A006_I',
        videoId: 'VENREL_A006_I',
        standaloneVideoElementId: 'VENREL_A006_I',
        videoURL: 'VENREL_A006_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A013_E',
        videoId: 'VENREL_A013_E',
        standaloneVideoElementId: 'VENREL_A013_E',
        videoURL: 'VENREL_A013_E.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A013_I',
        videoId: 'VENREL_A013_I',
        standaloneVideoElementId: 'VENREL_A013_I',
        videoURL: 'VENREL_A013_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A016_E',
        videoId: 'VENREL_A016_E',
        standaloneVideoElementId: 'VENREL_A016_E',
        videoURL: 'VENREL_A016_E.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A016_I',
        videoId: 'VENREL_A016_I',
        standaloneVideoElementId: 'VENREL_A016_I',
        videoURL: 'VENREL_A016_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A020_E',
        videoId: 'VENREL_A020_E',
        standaloneVideoElementId: 'VENREL_A020_E',
        
        videoURL: 'VENREL_A020_E.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A020_I',
        videoId: 'VENREL_A020_I',
        standaloneVideoElementId: 'VENREL_A020_I',
        videoURL: 'VENREL_A020_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENCPA_A050_I',
        videoId: 'VENCPA_A050_I',
        standaloneVideoElementId: 'VENCPA_A050_I',
        videoURL: 'VENCPA_A050_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A070_E',
        videoId: 'VENREL_A070_E',
        standaloneVideoElementId: 'VENREL_A070_E',
        videoURL: 'VENREL_A070_E.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A070_I',
        videoId: 'VENREL_A070_I',
        standaloneVideoElementId: 'VENREL_A070_I',
        videoURL: 'VENREL_A070_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_ANN_A065_I',
        videoId: 'VENREL_ANN_A065_I',
        standaloneVideoElementId: 'VENREL_ANN_A065_I',
        videoURL: 'VENREL_ANN_A065_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_COR_A068_I',
        videoId: 'VENREL_COR_A068_I',
        standaloneVideoElementId: 'VENREL_COR_A068_I',
        videoURL: 'VENREL_COR_A068_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_CRU_A066_I',
        videoId: 'VENREL_CRU_A066_I',
        standaloneVideoElementId: 'VENREL_CRU_A066_I',
        videoURL: 'VENREL_CRU_A066_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_MAD_A069_I',
        videoId: 'VENREL_MAD_A069_I',
        standaloneVideoElementId: 'VENREL_MAD_A069_I',
        videoURL: 'VENREL_MAD_A069_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_RES_A067_I',
        videoId: 'VENREL_RES_A067_I',
        standaloneVideoElementId: 'VENREL_RES_A067_I',
        videoURL: 'VENREL_RES_A067_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENSRM_A072_I',
        videoId: 'VENSRM_A072_I',
        standaloneVideoElementId: 'VENSRM_A072_I',
        videoURL: 'VENSRM_A072_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENWEL_A073_I',
        videoId: 'VENWEL_A073_I',
        standaloneVideoElementId: 'VENWEL_A073_I',
        videoURL: 'VENWEL_A073_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'VENREL_A049_I',
        videoId: 'VENREL_A049_I',
        standaloneVideoElementId: 'VENREL_A049_I',
        videoURL: 'VENREL_A049_I.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        // videoButtonScale: {x:.05,y:.05,z:1},
        // video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NANINTA083',
        videoId: 'NANINTA083',
        standaloneVideoElementId: 'NANINTA083',
        // videoURL: 'AlA01.mp3',
        videoURL: 'NANINTA083.mp3',
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        videoLoop: false,
        videoAutoPlayDelay: 0,
        videoButtonScale: {x:.05,y:.05,z:1},
        video_button_z_offset: .01,
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    // {
    //     paintingId: '',
    //     videoId: '',
    //     standaloneVideoElementId: '',
    //     videoURL: '.mp3',
    //     displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
    //     headerText: '',
    //     bodyText: null,
    //     displayMesh: 'Y',
    //     useVideoMeshButton: 'Y',
    //     displayHeight: 90,
    //     videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
    //     displayAudioSprite: 'N',
    //     videoLoop: false,
    //     videoAutoPlayDelay: 0,
    //     // videoButtonScale: {x:.05,y:.05,z:1},
    //     // video_button_z_offset: .01,
    //     // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
    //     // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
    //     // videoLoop: true,
    // },
    /* Audio */

    /* Videos */
    {
        paintingId: 'NANINTV083',
        videoId: 'NANINTV083',
        standaloneVideoElementId: 'NANINTV083',
        videoURL: 'NANINTV083.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        redisplayMeshAfterVideoEnd: 'Y',
        displayHeight: 90,
        // videoTextureEncoding: THREE.sRGBEncoding,
        videoAutoPlay: 'N',
        useVideoMeshButton: 'Y',
        // spriteImageURL: INFO_TAG,
    },
    /* Videos */

    /* Text Annotations */
    {
        paintingId: "VENREL_P001",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P001.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 27 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P002",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P002.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 258 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P003",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P003.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 111 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P004",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P004.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 142 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P005",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P005.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 102 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P006",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P006.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 145 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.42,
        annotation_location_horiz_offset: -0.42,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId: "VENREL_P007",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P007.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 100 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P008",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P008.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 108 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P009",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P009.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 82 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.48,
        annotation_location_horiz_offset: -0.08,
    },
    {
        paintingId: "VENREL_P010",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P010.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 72 cm (central painting)<br>Height: 100 cm (with wooded frame)`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P011",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P011.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 111 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P012",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P012.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 57 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P013",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P013.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 57 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.12,
        annotation_location_horiz_offset: -0.08,
    },
    {
        paintingId: "VENREL_P014",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P014.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 88 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P015",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P015.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 60 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P016",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P016.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 74 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P017",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P017.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 163 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.16,
        annotation_location_horiz_offset: -0.32,
    },
    {
        paintingId: "VENREL_P018",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P018.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 34 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P019",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P019.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 57 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P020",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P020.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 83 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.12,
        annotation_location_horiz_offset: 0.04,
    },
    {
        paintingId: "VENREL_P021",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P021.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 40 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P022",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P022.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 127 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P023",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P023.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 28.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P024",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P024.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 119 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P025",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P025.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 54.9 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P026",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P026.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 99.1 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P027",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P027.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 72 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.04,
        annotation_location_horiz_offset: -0.09,
    },
    {
        paintingId: "VENREL_P028",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P028.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 283 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        annotation_location_vert_offset: -0.16,
        annotation_location_horiz_offset: -0.16,
    },
    {
        paintingId: "VENREL_P029",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P029.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 229 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P030",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P030.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 10.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P031",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P031.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 26.7 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P032",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P032.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 70 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P033",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P033.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 33 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P034",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P034.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 69.3 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P035",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P035.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 33.3 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P036",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P036.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P037",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P037.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENCPA_P038",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENCPA_P038.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENTEX_P039",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENTEX_P039.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 25.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENTEX_P040",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENTEX_P040.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 53 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENTEX_P041",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENTEX_P041.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 44.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENTEX_P042",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENTEX_P042.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 62.2 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENGLA_P043",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENGLA_P043.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 13 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENGLA_P044",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENGLA_P044.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 19.5 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENGLA_P045",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENGLA_P045.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 22 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENGLA_P046",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENGLA_P046.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 18 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENGLA_P047",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENGLA_P047.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 19 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENGLA_P048",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENGLA_P048.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 22.3 cm`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "NANCIT_T057",
        videoId: "",
        videoURL: "",
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
        iframeSource: 'https://www.youtube-nocookie.com/embed/cZjsO8p9FlU',
        headerText: `<h6>Venice: Rise to Glory</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "NANCIT_T058",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/2_m8qA3H8OY',
        headerText: `<h6>Doges Palace</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "NANCIT_T059",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/_fAgls5bGXs',
        headerText: `<h6>Basilica of St Mark</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "NANCIT_T060",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/sjJ381Wd9dI',
        headerText: `<h6>Marco Polo</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "NANCIT_T061",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/n7KRrYD26nQ',
        headerText: `<h6>Murano Glasswork</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },

    {
        paintingId: "VENEXC_T053",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/k2itwlG8jPY',
        headerText: `<h6>Verona</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "VENEXC_T054",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/1b-UWJb0Zrg',
        headerText: `<h6>Basilica of St. Anastasia, Verona</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "VENEXC_T055",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/VhvRS7LdVug',
        headerText: `<h6>Padua</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
{
        paintingId: "VENEXC_T056",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/nEvhS9BRtuA',
        headerText: `<h6>Scrovegni Chapel Padua Giotto</h6>`,
        bodyText: ``,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
    {
        paintingId: "VENREL_P070",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}VENREL_P070.jpg/info.json`,
        headerText: `<h6></h6>`,
        bodyText: `Height: 118 cm (both)`,
        displayMesh: "Y",
        useMeshButton: "N",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    },
 {
        paintingId: "VENTHE_P076",
        videoId: "",
        videoURL: "",
        iframeSource: 'https://www.youtube-nocookie.com/embed/n1vI0ZPuJuQ',
        headerText: `<h6></h6>`,
        // bodyText: `The theatre features three pieces of religious music<br><br><br><ol><li>Venerating the relics of St Stephen Ave corpus sanctum gloriosi Stefani - Adolescens protomartyr (1330s)</li><li>Music for the feast of St Mark</li><li>Johannes Ciconia’s Venecie mundi splendor/Michael qui Stena domus (c. 1406) 3.40 minutes</li></ol><br><br>They can be heard in their original setting here: `,
        displayMesh: "Y",
        useMeshButton: "Y",
        // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
        // urlLink1Label: "CICONIA",
        // urlLink1: "https://www.youtube.com/watch?v=AACHYcp4l_s",
        // urlLink2Label: "LA-REVERDIE",
        // urlLink2: "https://www.youtube.com/watch?v=coVYyLsE4Jk",
        // urlLink3Label: "APPLE-STORE",
        // urlLink3: "https://music.apple.com/us/song/beatissimus-marcus-responsory-feast-of-st-mark-25/1362044462",
    },
// {
    //     paintingId: "",
    //     videoId: "",
    //     videoURL: "",
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h6></h6>`,
    //     bodyText: ``,
    //     displayMesh: "Y",
    //     useMeshButton: "N",
    //     // annotationScale: new THREE.Vector3(0.15, 0.15, 1),
    // },

    /* Text Annotations */

    /* Extras */
    {
        paintingId:"NANINTL124",
        videoId:"",
        videoURL:"",
        isMediaUsed: "N",
        headerText:"<h5>Sponsors</h5>",
        bodyText:`Blue Ninja: <u>https://blueninja.eu/</u><br>IIAS: <u>https://www.iias.asia/</u><br> New Silk Roads: <u>https://newsilkroads.info/</u>`,
        displayMesh:"N",
        useMeshButton:"N",
        urlLink2Label: "BlueNinja",
        urlLink2: "https://blueninja.eu/",
        urlLink3Label: "IIAS",
        urlLink3: "https://www.iias.asia/",
        urlLink1Label: "NSR",
        urlLink1: "https://newsilkroads.info/",
        spriteImageURL: INFO_TAG,
        annotation_location_vert_offset: 0.22,
        annotation_location_horiz_offset: -0.12,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId:"VENSRM_T072",
        videoId:"",
        videoURL:"",
        isMediaUsed: "N",
        headerText:"<h6>Silk Road Virtual Museum 1200-1450</h6>",
        bodyText:"Welcome to the Silk Road Virtual Museum. The museum is designed to portray the art and culture of the societies that spanned the area between Asia and Europe.<br><br>The first period covered by the Museum is that between 1200 and 1450CE. This is seen by historians as the last period of overland trade and cultural exchange. It also witnessed the first Chinese diplomatic voyages that reached the Red Sea and the coast of West Africa. Gradually the period will be rolled backward to earlier epochs.<br><br>" + "The museum is formed by a network of different ‘city’ locations; each chosen to represent a particular culture. Venice 1261-1453 is the second of these museums. " + "<br><br>Further information and eLibraries are available at:",
        displayMesh:"N",
        useMeshButton:"Y",
        urlLink1Label: "Silk Road VM-I",
        urlLink1: "https://silkroadvirtualmuseum.com/",
        urlLink2Label: "Silk Road VM-II",
        urlLink2: "https://silkroadvm.com/",
        spriteImageURL: INFO_TAG,
        annotation_location_vert_offset: -0.05,
        annotation_location_horiz_offset: -0.04,
        // annotation_location_z_offset: 1,
    },
    {
        paintingId:"NANDEPW127",
        videoId:"",
        videoURL:"",
        isMediaUsed: "N",
        headerText:`<h6>Silk Road Virtual Museum</h6>`,
        bodyText:`Thank-you for visiting the museum. If you would like to give us your feedback, to offer to help, to make a donation or to sign up for our newsletter, please click BELOW`,
        displayMesh:"Y",
        useMeshButton:"Y",
        urlLink1Label: "Silk Road Virtual Museum",
        urlLink1: "https://silkroadvirtualmuseum.com/landing/",
    },
    /* Extras */
];

export {AnnotationsDB};
